import {
  ofType
} from 'redux-observable';

import {
  ajax
} from "rxjs/ajax";

import { of } from 'rxjs';

import {
  map,
  switchMap,
  catchError,
} from 'rxjs/operators';

import { pushRoute, sendToGTMDataLayer } from '../../utilities/helpers';
import { setCredentials } from '../../utilities/localStorage';

import {
  SIGN_IN_USER,
  SIGN_IN_SUCCSESS,
  SIGN_IN_FAILURE,
} from '../constants';


const auth = (action$, state$) => action$.pipe(
  ofType(SIGN_IN_USER),
  switchMap(action =>
    ajax({
      url: `${state$.value.auth.server}/auth/signin?v=${process.env.REACT_APP_VERSION}`,
      body: {
        username: action.username,
        password: action.password,
      },
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'json',
      crossDomain: true,
      method: 'POST',
    }).pipe(
      map(response => {
        if(response.response.accounts.length > 1){
          setCredentials({
            token: response.response.token,
            firstName: response.response.user.firstName,
            lastName: response.response.user.lastName,
            accounts: response.response.accounts,
            currentAccountIndex: 0,
            expiresAt: response.response.accounts[0].expiresAt,
          });

          pushRoute('/select-account');
        }else{
          setCredentials({
            token: response.response.accounts[0].token,
            firstName: response.response.user.firstName,
            lastName: response.response.user.lastName,
            accounts: response.response.accounts,
            currentAccountIndex: 0,
            firstToSelectPage: false,
            expiresAt: response.response.accounts[0].expiresAt,
          });
          pushRoute('/loading');

        }


        // send client_id, user_id to DataLayer when login is success
        let dataObj = {
          "userId" : response.response.accountId,
          "clientId"  : response.response.clientId,
          'event': 'LoginSuccess'
        };

        //sendToGTMDataLayer(dataObj);
        return ({
          type: SIGN_IN_SUCCSESS,
          data: response.response,
        })
      }),
      catchError(error => of({
        type: SIGN_IN_FAILURE,
        error,
      }))
    ),
  )
);

export default auth;
